<template>
  <div class="p-4 pb-0 gap-4 flex items-center justify-between">
    <BaseBackButton
      v-if="!isBackButton"
      class="pointer-events-none invisible opacity-0"
      :to="{}"
    />

    <BaseBackButton v-else-if="isAuthorized" :to="{ name: 'hub.sections' }" />

    <BaseBackButton v-else :to="isDemo ? { name: 'demo' } : { name: 'home' }" />

    <div class="gap-1 flex flex-col text-center">
      <span class="text-sm font-bold text-[#7C7C7C]">{{ topic?.name }}</span>
    </div>

    <BaseIcon
      v-if="!isDemo"
      class="text-xl text-[#B3B3B3] cursor-pointer"
      icon="user-gear"
      @click="$emit('open-settings')"
    />

    <BaseBackButton
      v-else
      class="pointer-events-none invisible opacity-0"
      :to="{}"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import BaseBackButton from '@/components/Base/BaseBackButton.vue'
import BaseIcon from '@/components/Base/BaseIcon.vue'
// import BaseAvatar from '@/components/Base/BaseAvatar.vue'

export default {
  name: 'HubExercisesHeader',

  components: { BaseBackButton, BaseIcon },

  props: {
    // sectionSlug: { type: String, required: true },
    topic: { type: Object, required: true },

    isDemo: { type: Boolean, default: false },

    isBackButton: { type: Boolean, default: true }
  },

  computed: {
    // ...mapState('user', ['user']),
    ...mapGetters('auth', ['isAuthorized'])
  }

  // methods: {
  //   handleOpenProfile() {
  //     this.$router.push({ name: 'profile' })
  //   }
  // }
}
</script>
